import { addOnceEventListener } from '../../utils/helpers'

export default {

  props: {
    src: String,
    fill: Boolean,
    center: Boolean,
    zoomIntro: Boolean,
  },

  data() {
    return {
      loaded: false,
    }
  },

  render (h) {
    return h('img', {
      class: {
        'img': true,
        'img--fill': this.fill,
        'img--center': this.center,
        'img--zoom-intro': this.zoomIntro,
        'img--loaded': this.loaded,
      },
      domProps: {
        src: this.src,
        onload: () => {this.loaded = true; this.$emit('load', this)},
        onerror: () => this.$emit('error', this),
      }
    })
  },
}
